import { FecPushStatus } from '../enums/fecPushStatus'
import type { FecImportItem } from '../query-api'
import { isFecConfirmationIncomplete } from './isFecConfirmationIncomplete'

type FecThirdPartyConfirmationFields = Pick<
  FecImportItem,
  'entryPushStatus' | 'thirdPartyMappingStatus' | 'thirdPartyPushStatus'
>

/**
 * Whether the third-party confirm still has to run. Besides its own mapping and push, it is the confirm that
 * re-enters the opening-balance entry push (idempotent), so a failed or missing entry push keeps it open too.
 */
export const shouldConfirmFecThirdParties = ({
  entryPushStatus,
  thirdPartyMappingStatus,
  thirdPartyPushStatus,
}: FecThirdPartyConfirmationFields): boolean =>
  isFecConfirmationIncomplete(thirdPartyMappingStatus, thirdPartyPushStatus) ||
  entryPushStatus === FecPushStatus.PushFailed ||
  entryPushStatus === FecPushStatus.NotPushed
